import { CustomFormattedMessage } from '../../../../../i18n/i18n';
import { SIDEBAR_DATA_COLOR, SIDEBAR_LABEL_COLOR } from '../VehicleSidebar';
import { MaskedCardNumber } from '../../../../../components/MaskedCardNumber';
import { PaymentPartnerType } from '../../../../../codegen/vehicles';
import { PaymentPartnerRepresentation } from '../../../../../components/dataRepresentation/PaymentPartnerRepresentation';

type CardDetailsProps = {
  paymentPartner: PaymentPartnerType;
  lastFourDigits: string;
  expiry?: string;
};

export const CardDetails = ({
  paymentPartner,
  lastFourDigits,
  expiry,
}: CardDetailsProps) => {
  return (
    <>
      <tr>
        <td className={`width-50pct ${SIDEBAR_LABEL_COLOR}`}>
          <CustomFormattedMessage id={'common.card.type'} />
        </td>
        <td className={`${SIDEBAR_DATA_COLOR}`}>
          <PaymentPartnerRepresentation paymentPartner={paymentPartner} />
        </td>
      </tr>
      <tr>
        <td className={`width-50pct ${SIDEBAR_LABEL_COLOR}`}>
          <CustomFormattedMessage id={'common.card.number'} />
        </td>
        <td className={`${SIDEBAR_DATA_COLOR}`}>
          <MaskedCardNumber lastFourDigits={lastFourDigits} />
        </td>
      </tr>
      {expiry && (
        <tr>
          <td className={`width-50pct ${SIDEBAR_LABEL_COLOR}`}>
            <CustomFormattedMessage id={'common.card.expiryDate'} />
          </td>
          <td className={`${SIDEBAR_DATA_COLOR}`}>{expiry}</td>
        </tr>
      )}
    </>
  );
};
